const dotsModel = () => {
    return [
        {
          number: 1,
          label: 'Basic Information',
          selected: true,
          hasError: false,
          path: '/basicInformation'
        },
        {
          number: 2,
          label: 'Personal Information',
          selected: false,
          hasError: false,
          path: '/personalInformation'
        },
        {
          number: 3,
          label: 'Funding Sources',
          selected: false,
          hasError: false,
          path: '/fundingSources',          
        },
        {
          number: 4,
          label: 'Health',
          selected: false,
          hasError: false,
          path: '/health',          
        },
        {
          number: 5,
          label: 'Additional Information',
          selected: false,
          hasError: false,
          path: '/additionalInformation', 
        },
      ];
};

export default dotsModel;